import { Ref, RefKey } from '../../../../responses/refs/refs'
import { isDefined, pick } from '../../../../utils/utils'

export const refsConfig: Partial<Record<RefKey, Ref>> = {
    'department': {
        key: 'department',
        name: 'Отделы',
        columns: [],
    },
    'direction': {
        key: 'direction',
        name: 'Направления',
        columns: [{
            key: 'title',
            name: 'Название',
            required: true,
            type: 'text',
        }],
    },
    'work-type': {
        key: 'work-type',
        name: 'Тип проекта',
        editable: true,
        columns: [
            {
                key: 'name',
                name: 'Название',
                required: true,
                type: 'text',
            },
            {
                key: 'code',
                name: 'Код',
                required: true,
                type: 'text',
            },
            {
                key: 'counter',
                name: 'Номер последнего проекта',
                required: true,
                type: 'number',
            },
            {
                key: 'hidden',
                name: 'Скрытый',
                required: true,
                type: 'boolean',
                hide: true
            }
        ],
    },
    'task-type': {
        key: 'task-type',
        name: 'Типы задач',
        editable: true,
        columns: [],
    },
    'client': {
        key: 'client',
        name: 'Клиенты',
        editable: true,
        update_only: true,
        columns: [{
            key: 'short_title',
            name: 'Название',
            required: true,
            type: 'text'
        },{
            key: 'folder',
            name: 'Каталог',
            type: 'text',
        }],
    },
    'brand': {
        key: 'brand',
        name: 'Бренды',
        columns: [{
            key: 'title',
            name: 'Название',
            required: true,
            type: 'text',
        }],
    },
    'country': {
        key: 'country',
        name: 'Страна',
        editable: true,
        columns: [{
            key: 'code',
            name: 'Код',
            required: true,
            type: 'text',
        }],
    },
    'network': {
        key: 'network',
        name: 'Сеть/Издание',
        editable: true,
        columns: [{
            key: 'name',
            name: 'Название',
            required: true,
            type: 'text',
        }],
    },
    'work-object': {
        key: 'work-object',
        name: 'Объекты',
        editable: true,
        columns: [],
    },
    'work-object-category': {
        key: 'work-object-category',
        name: 'Категории',
        columns: [{
            key: 'name',
            name: 'Название',
            required: true,
            type: 'text',
        }],
    },
}

interface RouteConfig {
    key: string,
    name: string
}

export const additionalConfig: RouteConfig[] = [
    {
        key: 'user',
        name: 'Сотрудники'
    }
]

export const settingsRoutes: RouteConfig[] = Object.values(refsConfig)
    .filter(isDefined)
    .filter(ref => ref.key !== 'work-object-category')
    .filter(ref => ref.key !== 'direction')
    .filter(ref => ref.key !== 'department')
    .filter(ref => ref.key !== 'client')
    .filter(ref => ref.key !== 'brand')
    .filter(ref => ref.key !== 'work-object')
    .map<RouteConfig>(ref => pick(ref, 'key', 'name', 'category'))
    //.concat(additionalConfig)

export const settingsRoutesMore: RouteConfig[] = additionalConfig
    .concat(settingsRoutes)

export const additionalConfigFun: RouteConfig[] = additionalConfig
    .filter(ref => ref.key !== 'work-object-category')